// Imports
import { App } from './app.jsx';


var react_app_wrapper = document.querySelector("#react__app-wrapper-content");

// Don't run on a non-React page
if(react_app_wrapper !== null) {
    ReactDOM.render(
        
            <App />
     
    , react_app_wrapper);
}
